// removed by extract-text-webpack-plugin
module.exports = {"label":"label--label--3LhgAwan","isOrange":"label--isOrange--3SEE8OMz"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/Label/label.scss
// module id = 573
// module chunks = 0